/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Libellé sur deux niveaux : « mūsaelab | l'agence de mūsae » dans Settings → Navigation
   affiche « mūsaelab » avec « l'agence de mūsae » en petit dessous. À exécuter avant dropdown(),
   qui mémorise le menu tel quel. */
(function () {
    document.querySelectorAll('.gh-navigation .nav a, .gh-footer-menu .nav a').forEach(function (link) {
        const parts = link.textContent.split('|');
        if (parts.length < 2) return;
        const label = parts.shift().trim();
        const sublabel = parts.join('|').trim();
        if (!label || !sublabel) return;
        link.textContent = '';
        const main = document.createElement('span');
        main.className = 'nav-label';
        main.textContent = label;
        const sub = document.createElement('span');
        sub.className = 'nav-sublabel';
        sub.textContent = sublabel;
        link.append(main, sub);
        link.classList.add('has-sublabel');
        link.setAttribute('aria-label', label + ', ' + sublabel);
    });
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();

/* Page « mūsae lab » : sous-navigation ancrée et grille des études de cas */
(function () {
    if (!document.body.classList.contains('page-musae-lab')) return;

    const content = document.querySelector('.gh-lab .gh-content');
    const subnav = document.querySelector('.gh-lab-subnav');
    const list = subnav && subnav.querySelector('.gh-lab-subnav-list');
    const cases = document.querySelector('.gh-lab-cases');
    if (!content) return;

    const headings = Array.from(content.children).filter(function (el) {
        return el.tagName === 'H2' && el.id;
    });

    /* La grille des études de cas prend place juste après le titre qui les annonce */
    if (cases) {
        const anchor = headings.find(function (h) {
            const id = decodeURIComponent(h.id);
            return /[ée]tudes?-de-cas/i.test(id) || /études? de cas/i.test(h.textContent);
        });
        if (anchor) {
            anchor.insertAdjacentElement('afterend', cases);
            cases.classList.add('is-inline');
        }
    }

    /* Chaque h2 et ce qui le suit forment une bande de couleur (.gh-lab-section) */
    headings.forEach(function (h) {
        const section = document.createElement('section');
        section.className = 'gh-lab-section';
        h.parentNode.insertBefore(section, h);
        let node = h;
        while (node) {
            const next = node.nextSibling;
            section.appendChild(node);
            if (!next || (next.nodeType === 1 && next.tagName === 'H2' && next.id)) break;
            node = next;
        }
    });
    content.classList.add('has-sections');

    /* Sous-navigation construite à partir des h2 du contenu */
    if (list && headings.length > 1) {
        headings.forEach(function (h) {
            const li = document.createElement('li');
            const a = document.createElement('a');
            a.href = '#' + h.id;
            a.textContent = h.textContent.trim();
            li.appendChild(a);
            list.appendChild(li);
        });
        subnav.hidden = false;

        const links = Array.from(list.querySelectorAll('a'));
        let ticking = false;

        /* Section active : le dernier titre passé au-dessus du tiers haut de l'écran */
        const updateActive = function () {
            ticking = false;
            const line = subnav.getBoundingClientRect().bottom + Math.min(window.innerHeight * 0.25, 160);
            let current = headings[0];
            headings.forEach(function (h) {
                if (h.getBoundingClientRect().top <= line) current = h;
            });
            if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2) {
                current = headings[headings.length - 1];
            }
            links.forEach(function (a) {
                a.classList.toggle('is-active', a.getAttribute('href') === '#' + current.id);
            });
        };
        const onScroll = function () {
            if (!ticking) {
                ticking = true;
                window.requestAnimationFrame(updateActive);
            }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        updateActive();
    }
})();
